import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lists: [],
    packageJson: JSON.parse(unescape(process.env.PACKAGE_JSON || '%7B%7D')),
  },
  actions,
  mutations,
  getters,
});
